// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:CJcUy0 */\n.Vm9nz{display:flex;gap:var(--audio-spacing-8);justify-content:flex-start;min-width:0}.JJrxE{display:inline-flex}.NyhlJ{border-radius:var(--audio-radius-1);display:inline-flex;gap:var(--audio-spacing-8);min-width:0;overflow:hidden;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tags": "Vm9nz",
	"link": "JJrxE",
	"visible": "NyhlJ"
};
export default ___CSS_LOADER_EXPORT___;
